<template>

  <Features-Filter :ref="refs[builder.config.fieldName + 'FeaturesGroup']" v-if="!_.isNull(builder.currentSection.width)"></Features-Filter>

  <div class="group" :ref="refs[builder.config.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.config.fieldName}Title`">
      <div class="group-title">Choose your design.</div>
      <!-- <div class="group-help">The cabinet installation order can be changed to suit your design.</div> -->
    </div>

    <template v-if="!_.isNull(builder.currentSection.width) && builder.configOptionsForSection.length">

      <Selector
        :key=builder.config.fieldName
        :field-name=builder.config.fieldName
        :display-type=builder.config.displayType
        :options=builder.config.options
        :selected=builder.currentSection[builder.config.fieldName]
        options-source="configOptionsForSection"
        scope="section"
        @select-option="select"
        @view-info="viewInfo"
      ></Selector>

    </template>

    <p v-else-if="!_.isNull(builder.currentSection.width)">No designs available. Try adjusting your <strong><em>width</em></strong> and <strong><em>features</em></strong> to find available designs.</p>

    <!-- <a :href="builder.messages.noOptionsLinkUrl" target="_blank" class="nextsteps" v-if="builder.messages.noOptionsTitle">
      <div class="nextsteps-aside">
        <div class="nextsteps-imagewrapper">
          <div class="nextsteps-image" :style="`background-image: url(${builder.messages.noOptionsImageUrl});`"></div>
        </div>
      </div>
      <div class="nextsteps-main">
        <div class="nextsteps-title" v-html="builder.messages.noOptionsTitle"></div>
        <div class="nextsteps-content" v-html="builder.messages.noOptionsText"></div>
        <div class="nextsteps-btn button l_base" v-html="builder.messages.noOptionsLinkText"></div>
      </div>
    </a> -->

  </div>

  <!-- <div class="group" v-else-if="!_.isNull(builder.currentSection.width)">

    <div class="group-header">
      <div class="group-title">No designs available.</div>
      <div class="group-help">Please adjust your space width to find available designs.</div>
    </div>

  </div> -->

  <!-- <div class="group">

    <div class="group-header">
      <div class="group-title">Cabinet configuration & sizes</div>
      <div class="group-help">The below details are based on the design picked above.</div>
    </div>

    <div class="group-footer">
      <div v-html="builder.currentSectionConfigDescription" v-if="builder.currentSectionConfigDescription"></div>
      <div v-else><p>Please select a configuration.</p></div>
    </div>

  </div> -->

  <!-- <div class="wardrobe l_no-padding" :ref="refs['configDetailsGroup']" v-if="builder.currentSectionConfigDescription">
    <div class="wardrobe-inner">
      <div class="wardrobe-header l_wrap">
        <div class="wardrobe-title">Your selected inclusions:</div>
        <div class="wardrobe-supersubtitle">Below is a list of included cabinetry based on your design selection and wall space.</div>
      </div>
      <div class="wardrobe-main">
        <div v-html="builder.currentSectionConfigDescription" v-if="builder.currentSectionConfigDescription"></div>
        <div v-else><p>Please select a configuration.</p></div>
      </div>
    </div>
  </div> -->


</template>

<script setup>

var _ = require('lodash');

import { computed, ref } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

function select(prop, opt) {
  builder.setCurrentSectionSpec(prop, opt['id']);

  // one-click continue
  builder.saveCurrentItem(true);
}

function viewInfo(opt) {
  // let infoHtml = '<h4>Your selected inclusions:</h4>';
  // infoHtml += '<p>Below is a list of included cabinetry based on your design selection and wall space.</p>';
  // infoHtml += builder.currentSectionConfig;
  let infoHtml = builder.currentSectionConfigDescription;
  lightbox.open(infoHtml);
}

// init refs
let refHandles = [
  'configDetailsGroup',
  builder.config.fieldName + 'Group',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>
